import React, { useState, useEffect } from "react";
import { X, Smile } from "lucide-react";

export default function WelcomeModal() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Show modal only if hasSeenModal is NOT in localStorage
        const seen = localStorage.getItem("hasSeenModal");
        console.log(seen);

        if (seen === "true") {
            setIsOpen(false);
        } else {
            setIsOpen(true);
        }
    }, []);


    const fullName = localStorage.getItem("fullName") || "";

    // Capitalize first letter of each word
    const formattedName = fullName
        .split(" ")
        .map(namePart => namePart.charAt(0).toUpperCase() + namePart.slice(1))
        .join(" ");



    // Dismissing this greeting only means "don't show the popup again in this
    // browser" — it's tracked in localStorage only and is NOT the same thing
    // as having finished onboarding. (Previously this also PATCHed
    // hasSeenModal=true to the backend, which login/index.js used to decide
    // dashboard-vs-onboarding — so dismissing this popup, on its own, could
    // send an interrupted signup straight to the dashboard. Onboarding
    // completion is now tracked separately via `onboardingCompleted`, set
    // only at the true end of the wizard.)
    const handleClose = () => {
        localStorage.setItem("hasSeenModal", "true");
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center">
            <div className="bg-white rounded-2xl shadow-lg max-w-md w-full p-6 relative">
                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                >
                    <X className="w-5 h-5" />
                </button>

                {/* Icon */}
                <div className="flex justify-center mb-4">
                    <Smile className="w-10 h-10 text-blue-500" />
                </div>

                {/* Title */}
                <h2 className="text-2xl font-bold text-center mb-2">Welcome!, {formattedName} 🎉</h2>

                {/* Message */}
                <p className="text-gray-600 text-center mb-6">
                    We’re excited to have you here! Please answer a few quick questions so
                    we can personalize your experience.
                </p>

                {/* Continue Button */}
                <div className="flex justify-center">
                    <button
                        onClick={handleClose}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                    >
                        Let’s Go
                    </button>
                </div>
            </div>
        </div>
    );
}
